export function shouldOpenActivityCenterHelper(
  previousJobBookmarks: number,
  totalByEvents: Record<string, number>,
  origin: string
): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const currentJobBookmarks = totalByEvents.jobBookmarks ?? 0;
  const shouldOpen =
    (previousJobBookmarks === 0 && currentJobBookmarks === 1) ||
    (previousJobBookmarks === 1 && currentJobBookmarks === 2);

  return shouldOpen && origin !== 'checkout_page';
}
